import React, { useRef } from 'react';
import HomePageHeroCard from './Home/HomePageHeroCard';
import SubHeroComp from './Home/SubHeroComp';
import StatsBlock from './Home/StatsBlock'; 
import OurServicesSection from './Home/OurServicesSection';
import OurClientsCarousel from './Home/OurClientsCarousel'; 
import TestimonialList from './Home/TestimonialList'; 
import CTASectionCard from './Home/CTASectionCard';
import HomeSEO from './../seo/HomeSEO';
import { Helmet } from "react-helmet-async";

import '../css/Home.css';

export default function Home() {

  return (
    <>

       <Helmet>
              <title>Madeshwara Ambulance Services | 24/7 Ambulance Services in Bangalore and Karnataka</title>
       </Helmet>


      <main className="min-h-screen bg-white bg-opacity-90 backdrop-blur-[32px] font-sans 
            transition-colors duration-500 ease-in-out">

        <HomeSEO />

        {/* Hero Section */}
        <section aria-label="Ambulance Service in Bengaluru Madeshwara Ambulance service">
          <HomePageHeroCard />
        </section>

        {/* SubHeroComp */}
        <section 
          aria-label="Ambulance service advantages"
          className="w-full mx-auto ">
          <SubHeroComp />
        </section>

        {/* Quick Stats and Trust Signals */}
        <section className="max-w-6xl mx-auto px-4">
          <StatsBlock />
        </section>

        {/*Services Provided */}
        <section className="max-w-full mx-auto px-6 py-6 relative " >
          <OurServicesSection />
        </section>

        {/* Client Logos Strip */}
        {/* <section>
          <OurClientsCarousel />
        </section> */}

        {/* Testimonials Carousel */}
        <section className="max-w-4xl mx-auto my-10 px-4">
          <TestimonialList />
        </section>

        {/* CTA Section */}
        <section>
          <CTASectionCard />
        </section>

      </main>
    </>
  );
}
